// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__287gI","content":"styles_content__29l3C"};